import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const SyntheraLaunchBar = () => {
  const services = [
    {
      id: "01",
      title: "Consult",
      description:
        "Strategic security advisory to help you make the right decisions across risk, architecture, and investment.",
      link: "/services/security-consulting-advisory",
    },
    {
      id: "02",
      title: "Implement",
      description:
        "End-to-end implementation of security architectures aligned to your environment, scale, and risk.",
      link: "/services/design-and-deploy",
    },
    {
      id: "03",
      title: "Manage",
      description:
        "Running and continuously optimizing your security to reduce risk and keep pace with change.",
      link: "/services/managed-security-services",
    },
    {
      id: "04",
      title: "Defend",
      description:
        "Proactively hunting, detecting, and responding to threats before they impact your business.",
      link: "/services/detection-and-response",
    },
  ];

  return (
    <ScrollReveal>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');
          
          .synthera-section { 
            font-family: 'Inter', sans-serif; 
          }

          .accent-underline {
            height: 2px;
            width: 80px;
            background: linear-gradient(90deg, #facc15 0%, #f97316 100%);
            margin-top: 8px;
          }
        `}
      </style>

      {/* Reduced top/bottom section spacing */}
      <section className="synthera-section w-full py-24 bg-white">
        <div className="w-full max-w-full px-4 md:px-8">
          {/* Reduced heading bottom margin */}
          <div className="text-center mb-14">
            <h2 className="text-4xl md:text-5xl font-light text-[#333] tracking-tight">
              What We Do
            </h2>
          </div>

          {/* Full width grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {services.map((service, index) => (
              <div
                key={index}
                /* Reduced card height and vertical padding */
                className="service-card bg-[#f5f7fd] px-12 py-10 flex flex-col min-h-[390px] w-full"
              >
                <h3 className="text-[28px] font-medium text-[#222] mb-8">
                  {service.title}
                </h3>

                <p className="text-[#555] text-[16px] leading-relaxed mb-10 flex-grow">
                  {service.description}
                </p>

                <div className="mt-auto group">
                  <Link
                    to={service.link}
                    className="inline-flex items-center gap-3 text-[12px] font-bold tracking-[0.15em] text-[#333] no-underline uppercase"
                  >
                    <ArrowRight className="w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-transform" />
                    LEARN MORE
                  </Link>

                  <div className="accent-underline"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default SyntheraLaunchBar;
